import * as React from 'react';


export default class Button extends React.PureComponent {
  render() {
    let {style, secondary, size, onClick, ...others} = this.props;

    if (secondary) {
      if (!size) {
        size = '0.8';
      }
      style = {
        background: '#7986CB',
        ...style
      }
    }
    else {
      if (!size) {
        size = '20px'
      }
    }

    return <a
      href=""
      onClick={this.handleClick}
      style={{
        display: 'inline-block',
        textAlign: 'center',
        background: 'rgb(93, 111, 210)',
        padding: '0.7em',
        fontSize: (typeof size == 'string' && size.indexOf('px') > -1)
          ? size : `${size}em`,
        lineHeight: (typeof size == 'string' && size.indexOf('px') > -1)
          ? size : `${size}em`,
        color: 'white',
        textShadow: 'none',
        ...style
      }}
      role="button"
      {...others}
    />
  }

  handleClick = (e) => {
    if (this.props.href && this.props.href.startsWith('http'))
      return;

    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Button.js